import * as React from 'react';
import Barcodes from '../barcode/Barcodes';
import PrimaryFields from '../fields/PrimaryFields';
import SecondaryAndAuxiliaryFields from '../fields/SecondaryAndAuxiliaryFields';
import LogoTextHeaderFields from './LogoTextHeaderFields';
import ImagePreview from '../images/ImagePreview';
import { ImageTypes } from '../../../../types';
import { useStyles } from './styles';
import { useTheme } from '../../Theme';
export default function StoreCard() {
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoTextHeaderFields, null), /*#__PURE__*/React.createElement(ImagePreview, {
    imageType: ImageTypes.strip
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.primaryFieldContainer
  }, /*#__PURE__*/React.createElement(PrimaryFields, null)), /*#__PURE__*/React.createElement(SecondaryAndAuxiliaryFields, null), /*#__PURE__*/React.createElement(Barcodes, null));
}
//# sourceMappingURL=StoreCard.js.map